export enum UserFilter {
  ALL_USERS,
  ALL_NEW_USERS,
  ALL_USERS_GDPR,
  CANCEL,
}
